"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroupStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Spacer = require("../../layout/Spacer");
var _constants = require("../constants");
var _imageUploaderTheme = require("./imageUploaderTheme");
const shouldForwardPropToBaseComponent = prop => {
  switch (prop) {
    // Add any props that should NOT be forwarded to Base Component here.
    case "themeMode":
      return false;
    default:
      return true;
  }
};
const ButtonGroupStyled = (0, _styled.default)(_Spacer.Spacer, {
  shouldForwardProp: shouldForwardPropToBaseComponent
})`
    margin-top: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _imageUploaderTheme.imageUploaderTheme.buttonGroup.marginTop(themeMode);
}}px;
    .${_constants.IMAGE_CLASS} & {
        ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return themeMode.includes("ursa") && `
        position: absolute;
        margin-top: 0px;
        top: 8px;
        right: 8px;
    `;
}}
    }
`;
exports.ButtonGroupStyled = ButtonGroupStyled;
//# sourceMappingURL=ButtonGroupStyled.js.map